<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('user.fundingDetails')"
      @backurl="$router.back()"
    />
    <div class="item_wrap">
      <div class="tabs">
        <van-tabs
          v-model="active"
          color="#2563eb"
          title-active-color="#111"
          title-inactive-color="#64748b"
          line-width="20px"
          @click="sort"
        >
          <van-tab
            v-for="(tab, index) in tabs"
            :key="index"
            :title="tab"
          />
        </van-tabs>
      </div>
      
      <div class="item_list">
        <van-list
          v-model="loading"
          loading-text=" "
          offset="0"
          :finished="finished"
          :finished-text="$t('utils.noData')"
          @load="onLoad"
        >
          <div
            v-for="(item,index) in list"
            class="card_box item"
            :key="index"
          >
            <!-- 日期 + 状态标签 -->
            <div class="top_row">
              <span class="time_text">{{ item.act_time }}</span>
              <span class="status_tag" :class="item.type == 1 ? 'tag_income' : 'tag_expense'">
                <span class="icon">
                  <span v-if="item.type == 1">↗</span>
                  <span v-else>↘</span>
                </span>
                {{ item.type == 1 ? $t('tabs.income') : $t('tabs.expenditure') }}
              </span>
            </div>
            
            <!-- 描述 + 金额 -->
            <div class="bottom_row">
              <span class="desc_text">{{ $t('fundType.type'+item.fund_type) }}</span>
              <span class="money_text" :class="item.type == 1 ? 'money_income' : 'money_expense'">
                <span v-if="item.type == 1">+</span>
                <span v-else>-</span>
                {{ currency_symbol_basic }}{{ precision_basic(item.money) }}
              </span>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import {
  Tab,
  Tabs,
  List,
  Empty
} from 'vant';
Vue.use(Tab).use(Tabs).use(List).use(Empty);

export default {
  name: "FundingRecord",
  components: {
    bsHeader
  },
  data() {
    return {
      currency_symbol_basic: localStorage.getItem('currency_symbol_basic'),
      data: [],
      tabs: [
        this.$t('tabs.all'),
        this.$t('tabs.income'),
        this.$t('tabs.expenditure')
      ],
      active: 0,
      empty: false,
      loading: false,
      finished: false,
      list: [],
      page: 1,
      listRows: 8,
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    if (this.$router.history.current.query.type) {
      this.active = parseInt(this.$router.history.current.query.type);
    }
  },
  methods: {
    precision(money) {
      var precision = localStorage.getItem('precision');
      return (money / 1).toFixed(precision);
    },
    precision_basic(money) {
      var precision = localStorage.getItem('precision_basic');
      return (money / 1).toFixed(precision);
    },
    sort(type) {
      this.page = 1;
      this.empty = false;
      this.list = [];
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    onLoad() {
      Fetch('/user/fundingRecord', {
        page: this.page,
        listRows: this.listRows,
        type: this.active
      }).then(r => {
        if (r.data.length == 0) this.empty = true;
        var list = r.data.list;
        for (var i = 0; i < list.length; i++) {
          this.list.push(list[i]);
        }
        if (this.list.length >= r.data.length) {
          this.finished = true;
          return;
        }
        this.page = this.page + 1;
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  position: relative;
  padding-bottom: 60px;
  height: 100%;
  min-height: 100vh;
  /* 截图中的浅蓝网格背景 */
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

.item_wrap {
  width: 100%;
  padding: 5px 0 0 0;

  .tabs {
    position: sticky;
    top: 44px; /* 让Tabs在Header下方固定 */
    z-index: 99;
    background: #f0f4fa;
    padding-top: 4px;
    padding-bottom: 2px;
  }

  .item_list {
    margin-top: 10px;
    padding: 0 16px;

    /* ================= 单条数据卡片 ================= */
    .item {
      background: #ffffff;
      border-radius: 16px;
      padding: 16px;
      margin-bottom: 12px;
      box-shadow: 0 2px 8px rgba(24, 61, 122, 0.04);
      border: 1px solid rgba(176, 202, 240, 0.3);

      /* 第一行 (时间 + 状态标签) */
      .top_row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;

        .time_text {
          color: #64748b;
          font-size: 13px;
        }

        .status_tag {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 2px 10px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 600;
          
          .icon {
            font-size: 14px;
            font-weight: 300;
            line-height: 1;
          }

          &.tag_income {
            background: #dcfce7;
            color: #16a34a;
          }
          &.tag_expense {
            background: #fee2e2;
            color: #dc2626;
          }
        }
      }

      /* 第二行 (描述 + 金额) */
      .bottom_row {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .desc_text {
          font-size: 15px;
          font-weight: 600;
          color: #111;
        }

        .money_text {
          font-size: 16px;
          font-weight: 700;
          &.money_income {
            color: #16a34a; /* 收入绿色 */
          }
          &.money_expense {
            color: #dc2626; /* 支出红色 */
          }
        }
      }
    }
  }
}

/* ================= Vant Tabs 样式覆盖 ================= */
/deep/ .van-tabs__nav {
  background-color: transparent !important;
}
/deep/ .van-tab {
  color: #64748b;
  font-weight: 600;
}
/deep/ .van-tab--active {
  color: #111;
}
/deep/ .van-tabs__line {
  background-color: #2563eb !important;
  height: 3px;
  border-radius: 2px;
}
/deep/ .van-tabs__wrap {
  margin-bottom: 8px;
}
</style>